import React, { Component } from 'react';
import axios from 'axios';
import config from '../dummy_data/configuration.json';
import Navigation from '../components/Navigation'
import Breadcrumb from '../components/Breadcrumb'
// import Footer from '../components/Footer'
import SimpleFooter from '../components/SimpleFooter'
import {get, post, put, del} from '../DAL/Request'
import {BreadcrumbItems} from '../dummy_data/localizationItems.json'


class CaseDetail extends Component {

	// static propTypes = {
	// 	newsItem: PropTypes.object.isRequired
	// }

	constructor () {
		super()
		this.state = {
			footerItem: {},
			caseItem: [],
			showMobileMenu: false
		}
	}

	componentWillMount() {
		// console.log(this.props.match.params.id);
		if(this.props.match.params.id){
			this._refreshData(this.props.match.params.id);
		}

		this._getFooter();
	}

	handleShowHideMobileMenu(){
		this.setState({
	      showMobileMenu: !this.state.showMobileMenu
	    });
	}

	handleScreenClick(event){
		if(event.target.tagName !== "A" && event.target.className !== "fa fa-bars" && event.target.className !== "navigation-folded" && event.target.offsetParent.className.indexOf("mobile") < 0){
			this.setState({
		      showMobileMenu: false
		    });
		}
	}

	_refreshData = (id) => {
		axios({
	        method: 'GET',
	        url: `${config.caseItemsAction}/${id}`,
	        responseType:'json',
	        headers: {'requestType': 'FN'}
	    }).then((res)=>{
            console.log(res);
            this.setState({
            	caseItem: res.data
            });
        }).catch((err)=>{
            console.log(err.status);
        })
	}

	_buildLocation = () => {
		const location = [];
		location.push({
			name: localStorage.getItem("isEnglish") === "true"? BreadcrumbItems.find(i => i.fieldName === "Case").eName : BreadcrumbItems.find(i => i.fieldName === "Case").name,
			url: "/case"
		});
		// location.push({
		// 	name: this.state.newsItem.NewsType === "Enterprise"? "企业新闻" : "行业动态",
		// 	url: `/news/${this.state.newsItem.NewsType}`
		// });
		location.push({
			name: this.state.caseItem.Title,
			url: this.props.match.url
		});

		// console.log(this.props);

		return location;
	}

	_getFooter = () => {
		axios({
	        method: 'GET',
	        url: config.footerAction,
	        responseType:'json',
	        headers: {'requestType': 'FN'}
	    }).then((res)=>{
            // console.log(res);
            this.setState({
            	footerItem: res.data
            });
        }).catch((err)=>{
            console.log(err.status);
        })
	}


	render() {
		const location = this._buildLocation();
		let parentList = {}
		if(location.length > 1){
			parentList = `#${location[location.length - 2].url}`;
		}
		return(
			<div onClick={this.handleScreenClick.bind(this)}>
				<Navigation showMobileMenu={ this.state.showMobileMenu } handleShowHideMobileMenu={ this.handleShowHideMobileMenu.bind(this)}/>
				<div className="banner"><img src={require("../img/news.jpg")} alt="" /></div>
				<div className="content-container">
					<Breadcrumb location={location} />
					<div className="news-detail">
						<h2>{this.state.caseItem.Title}</h2>
						<div className="news-detail-info">
							来源：OWM<i></i>
							发布日期：<em>{this.state.caseItem.Created}</em><i></i>
							浏览：<span>162</span>
							<a href={parentList} target="_blank"><span>返回列表</span></a>
						</div>
						<div className="news-detail-content" dangerouslySetInnerHTML={{__html: this.state.caseItem.Content}}>
						</div>
					</div>
				</div>
				{/*<Footer item={this.state.footerItem} />*/}
				<SimpleFooter item={this.state.footerItem} />
			</div>
		)
	}
}

export default CaseDetail;


// WEBPACK FOOTER //
// ./src/pages/CaseDetail.js